import { selectedCompaniesState } from '@/features/companies/companies.state';
import { searchQueryState } from '@/features/search/global-search/search.state';
import { trackSearchAddFlowOpened } from '@/lib/mixpanel/mixpanel';
import { modalState } from '@/state/modal.state';
import { IconButton } from '@/ui/button/icon-button';
import { Inline } from '@/ui/line/line';
import { Tooltip } from '@/ui/tooltip/tooltip';
import { PERMISSION } from '@/user/permissions/permission.type';
import { useUserPermissions } from '@/user/permissions/use-user-permissions';
import { useAtomValue, useSetAtom } from 'jotai';
import { useTranslation } from 'react-i18next';

export const CompanyActions = ({
  companyId,
  companyName,
}: {
  companyId: string;
  companyName: string;
}) => {
  const { t } = useTranslation('companies');
  const setModalState = useSetAtom(modalState);
  const { hasRequiredPermission } = useUserPermissions();
  const setSelectedCompanies = useSetAtom(selectedCompaniesState);
  const searchQuery = useAtomValue(searchQueryState);

  return (
    <Inline alignItems="center" justifyContent="center">
      {hasRequiredPermission(PERMISSION.ADD_COMPANIES_TO_PROJECTS) && (
        <Tooltip content={t`companies.companyActions.addToProject`}>
          <IconButton
            variant="primary"
            icon="Plus"
            onClick={e => {
              e.stopPropagation();
              trackSearchAddFlowOpened({
                flow_type: 'addCompanyToProjects',
                search_query: searchQuery.search ?? '',
              });
              setSelectedCompanies([{ organizationId: companyId }]);
              setModalState({ state: 'addCompanyToProjects', companyName });
            }}
          />
        </Tooltip>
      )}
    </Inline>
  );
};
